// src/config/msalConfig.ts

export const msalConfig = {
    auth: {
        clientId: import.meta.env.VITE_MICROSOFT_CLIENT_ID,
        authority: "https://login.microsoftonline.com/common/v2.0", // Multi-tenant y v2.0
        redirectUri: import.meta.env.VITE_MICROSOFT_REDIRECT_URI,   // Debe coincidir con la configuración en Azure AD
        postLogoutRedirectUri: import.meta.env.VITE_MICROSOFT_REDIRECT_URI, // Redirección tras el cierre de sesión
    },
    cache: {
        cacheLocation: "sessionStorage", // Puedes cambiarlo a "localStorage" si prefieres persistencia
        storeAuthStateInCookie: false,   // Útil si hay problemas con navegadores antiguos
    },
    system: {
        loggerOptions: {
            logLevel: 2, // Info
            piiLoggingEnabled: false,    // Desactiva la impresión de datos personales
        },
    },
};

export const loginRequest = {
    scopes: ["openid", "profile", "email", "User.Read"], // Scopes recomendados para obtener información del usuario
};